import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DDLModes } from '../../../components/ui/controls/ddl-input/ddl-input.component';
import { TextModes } from '../../../components/ui/controls/text-input/text-input.component';
import { UnitsOfMeasureMC } from '../../../core/constants';
import { UIHelpers } from '../../../core/ui-helpers';
import { L2L3Data } from '../../../models/orders/L2L3Data';
import { OrderDetails } from '../../../models/orders/orderDetails';
import { TaxList } from '../../../models/ui/taxList';
import { IconType } from '../../../../../../../libs/Shared/components/icon/icon';

@Component({
  selector: 'app-terminal-L2L3',
  templateUrl: './terminal-L2L3.component.html',
  standalone: false,
})
export class TerminalL2L3Component {
  @Input() hidden: boolean = false;
  @Input() L2L3Data: Partial<L2L3Data>;

  IconType = IconType;
  InputTextModes = TextModes;
  DDLModes = DDLModes;

  taxList: TaxList[] = [];
  shippingCost: string | undefined;

  constructor() {
    this.L2L3Data = L2L3Data.createEmpty();
    this.taxList = [
      new TaxList({
        type: '',
        amount: undefined,
      }),
    ];
  }

  txtShippingCost_keyup() {
    this.L2L3Data.shippingAndHandlingAmount = parseFloat(
      this.shippingCost || '0',
    );
  }

  handleProductCodeChanged(productCode: string) {
    this.L2L3Data.productCode = productCode;
  }

  handleQuantityChanged(quantity: string) {
    this.L2L3Data.quantity = parseInt(quantity);
  }

  handleUnitOfMeasureChanged(unitOfMeasure: string) {
    this.L2L3Data.unitOfMeasure =
      UnitsOfMeasureMC[unitOfMeasure as keyof typeof UnitsOfMeasureMC].code;
  }

  handleDutyAmountUpdated(dutyAmount: string) {
    this.L2L3Data.dutyAmount = parseFloat(dutyAmount) || 0;
  }

  handleShippingAndHandlingAmountUpdated(shippingAndHandlingAmount: string) {
    this.L2L3Data.shippingAndHandlingAmount =
      parseFloat(shippingAndHandlingAmount) || 0;
  }

  handleTaxTypeChanged(taxType: string, index: number) {
    this.taxList[index].type = taxType;
    this.L2L3Data.taxes = this.taxList;
  }

  handleTaxAmountChanged(taxAmount: string, index: number) {
    this.taxList[index].amount = parseFloat(taxAmount);
    this.L2L3Data.taxes = this.taxList;
  }

  handleAddTaxClicked() {
    this.taxList.push(
      new TaxList({
        type: '',
        amount: undefined,
      }),
    );
  }

  handleRemoveTaxClicked(event: Event, index: number) {
    this.taxList.splice(index, 1);
    if (this.taxList.length == 0) {
      this.taxList.push(
        new TaxList({
          type: '',
          amount: undefined,
        }),
      );
    }
  }

  toggle() {
    this.hidden = !this.hidden;
  }

  clear() {
    this.L2L3Data = L2L3Data.createEmpty();
    this.taxList = [
      new TaxList({
        type: '',
        amount: undefined,
      }),
    ];
    this.shippingCost = undefined;
    this.hidden = true;
  }
}
